import React, { useEffect, useState } from 'react';
import { Button, Divider, IconButton, styled, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import phone from '../../../src/assets/Schedule/phone1.svg';
import calender from '../../../src/assets/Schedule/SVG (1).svg'
import reschedule from '../../../src/assets/Schedule/reschedule.svg';
import checkout from '../../../src/assets/Schedule/checkout.svg'
import payment from '../../../src/assets/Schedule/taskbutton.svg';
import dollar from '../../../src/assets/Schedule/dollar.svg';
import MicIcon from '@mui/icons-material/Mic';
import { useNavigate } from "react-router-dom";
// dollar
import timer from '../../../src/assets/Schedule/time.svg'
import dayjs from 'dayjs';
import './box.css';

import api from '../../api/api';
import AppointmentCard from './AppointmentCard';
import ToastMessage from '../../utils/mui/righttoptoast';
import ConfirmCheckoutModal from './chcekoutconformmodal';
import { calendericonblue } from '../../utils/svgs/svgcode';
import { outlinedbluecalender,outlinedblueclock } from '../../utils/svgs/svgcode';
import ConfirmCancelModal from './cancelConformationModal';
const CreateAppointment = ({setOrderData,setIsAptcard,fetchScheduleData,isfutureappointment,
   setNavigateTo, setScreen ,appointmentCardopen ,selectedAppointment,flow=''}) => {
    const [selectedDate, setSelectedDate] = React.useState(dayjs());
    const [showAppointmentForm, setShowAppointmentForm] = useState(false);
    const [isLoading, setIsLoading] = useState(false); 
    const [checkoutloading,setCheckoutLoading]=useState(false)
    const navigate=useNavigate()
    const [showTextArea, setShowTextArea] = useState(false);
    const[tableData,setTableData]=useState([])
    const [selectedCard, setSelectedCard] = useState();
    const practiseid = window.getPracticeId();
    const [orderOptions, setOrderOptions] = useState([]);
    const [isOrderLoading, setIsorderLoading] = useState(false); 
    const [openToast, setOpenToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastSeverity, setToastSeverity] = useState('success');
    const [deleteloading,setDeleteloading]=useState(false)
    const [CheckoutConformation,setCheckoutconformation]=useState(false)
       const [selectedOrders, setSelectedOrders] = useState([]);
    const [provider, setProvider] = useState("");
    const [selectedSlot,setSelectedSlot]=useState('')
    const [openCancelModal, setOpenCancelModal] = useState(false);

    const[appointmentname,setAppointmentName]=useState('')
    const [providername,setProvidername]=useState('');
    const [appointmentType, setAppointmentType] = useState("");
    const [rowId,setRowId]=useState(null);
    const [isReschedule, setIsReschedule] = useState(false); 
const[isorderschedule,setOrderSchedule]=useState(false)
const[selectedscheduleorder,setSelectedScheduleOrder]=useState('')
    const handleDateChange = (prop) => {
        setSelectedDate(prop);
    };

    const handleaddnoteClick = () => {
      setShowTextArea(!showTextArea); // Toggle the text area visibility
    };

    const handleToastClose = () => {
      setOpenToast(false)
  };
  
    const toggleFormVisibility = () => {
      setShowAppointmentForm(!showAppointmentForm);
    };
  
    const fetchdata=async(dt)=>{
      setIsLoading(true)
    try {
      const appointmentsdata=await api.get(`/v1/${practiseid}/appointments/${selectedAppointment?.patientid}/future`
      //   ,{
      // "scheduledate": dt
      // }
    )
    if(appointmentsdata.status===200){
      setTableData(appointmentsdata.data)
    }else{
      setTableData([])
    }
      
    } catch (error) {
      console.log(error)
    }finally{
      setIsLoading(false)
    }
 }
// setScreen - 2-Visit Status , 3-Payment
 useEffect(()=>{
  document.title = "CHIM - Scheduler";
  // console.log("selectedAppointment ",selectedAppointment);
   if(appointmentCardopen){
    fetchdata(selectedDate.format('YYYY-MM-DD'))     
   }
 
 },[appointmentCardopen])

 const handleCardClick = (upcomming,id) => {
  setSelectedCard(id === selectedCard ? null : id);  // Toggle selection
  fetchOrderData({orderStartDate:upcomming.startdate})
  setRowId(upcomming)
  if(flow!=='db'){
               setOrderData(upcomming)
        }

};


 const fetchOrderData = async ({orderStartDate}) => {
  const formattedStartDate = dayjs(orderStartDate).format('YYYY-MM-DD');
  // console.log("fStartDate",formattedStartDate);
   setIsorderLoading(true)
  try {
    const response = await api.post(`/v1/${practiseid}/scheduler/patients/${selectedAppointment?.patientid}/get_orders`, {
      startdate: formattedStartDate, // Payload to send in POST request
    });
    if (response.status === 200) {
      setOrderOptions(response.data); // Set the order data on success
    } else {
      setOrderOptions([]); // Clear if response is not successful
    }
  } catch (error) {
    console.error(error);
    setOrderOptions([]); // In case of error, clear the options
  } finally {
    setIsorderLoading(false); // Stop loading
  }
};


  const deleteAppointment=async(rowId)=>{
  setDeleteloading(rowId)
  console.log('iddcs',rowId)
  try {
    const response=await api.delete(`/v1/${practiseid}/scheduler/cancelschedule`,{
     data: {
        "rowid": rowId.id,
        "notes": "test delete"
      }}
    )
    
    if(response.status==200){
      setToastMessage("schedule cancelled successfully");
      setToastSeverity('success');
      setOpenToast(true);
  
      fetchdata()
    }else{
      setToastMessage('Failed to Cancel schedule. Please try again.');
      setToastSeverity('info');
      setOpenToast(true);
    }
    
  } catch (error) {
    console.log(error)
    setToastMessage('Something Went Wrong');
    setToastSeverity('error');
    setOpenToast(true);
  }finally{
    setDeleteloading(false)
  }
  
  }
  useEffect(() => {
    if (tableData && tableData.length > 0) {
      // Automatically call handleCardClick for the first appointment (index 0)
      handleCardClick(tableData[0],0 );
      setSelectedCard(0)

      console.log("DDDDDDDDDDDDDDD ", {
  selectedAppointment,
  tableDataItem: tableData[selectedCard],
  selectedCard,
  checkoutloading,
  isfutureappointment,
  flow,
  orderOptionsLength: orderOptions?.length,
  isToday: dayjs(tableData[selectedCard]?.startdate)
    .isSame(dayjs(), 'day')
});
    }
  }, [tableData]); 

  const SelectDate = new Date(selectedAppointment.startdate);
  const formattedDate = SelectDate.getFullYear() + '-' 
                       + (SelectDate.getMonth() + 1).toString().padStart(2, '0') + '-'
                       + SelectDate.getDate().toString().padStart(2, '0');

const checkoutuser=async()=>{

  try {
    setCheckoutLoading(true)
      // const response = await api.put(`/v1/${practiseid}/appointments/visit-purpose/update`, {
      //   "itemVal": 'Checked Out', // Pass the selected status value
      //   "dtype": ['dtvisit'],
      //   "app_id": [selectedAppointment.appointmentid],
      //   "cid": [selectedAppointment.AID],
      //   "searchdate": formattedDate
      // });
const matchingAppointments = tableData.filter(item =>
  item.startdate?.slice(0, 10) === selectedAppointment.startdate?.slice(0, 10)
);

const app_id = matchingAppointments.map(item => item.appointmentid);
const cid = matchingAppointments.map(item => item.id); // Make sure AID exists
const dtype = Array(app_id.length).fill("dtvisit");

const response = await api.put(`/v1/${practiseid}/appointments/visit-purpose/update`, {
  itemVal:Array(app_id.length).fill("Checked Out") ,
  dtype,
  app_id,
  cid,
  searchdate: formattedDate,
});

      if (response.status === 200) {

        setToastMessage(" Visit Status Updated successfully");
        setToastSeverity('success');
        setOpenToast(true);
        if(flow!=='db'){
               fetchScheduleData(selectedDate);
        }
           
 setTimeout(() => {
  if(flow!=='db'){
              setIsAptcard(false);
        }
 
}, 1500);
      } else {
        console.error("Update failed.");
        setToastMessage('Failed to Update Visit Status. Please try again.');
        setToastSeverity('info');
        setOpenToast(true);
      }
    } catch (error) {
      console.error('Error updating status:', error);
      setToastMessage('Something Went Wrong');
      setToastSeverity('error');
      setOpenToast(true);
    }finally{
      setCheckoutLoading(false)
    }
}
useEffect(()=>{
console.log( tableData[selectedCard])
},[selectedCard])

let disablebuttons=[ "Ready for Triage","Checked Out", 'In-Office - Confirmed', "Tele - Confirmed","Tele - left VM","In-Office - left VM","Awaiting Check In","Ready for Provider",'Processing']

const recordingProvider = selectedAppointment?.signintime?.BlinkscribeRecordingBy ?? null;
console.log("recordingProvider ", recordingProvider);

  return (
    <div
      className="fixed inset-0 z-50 flex justify-center items-start bg-black bg-opacity-50"
      onClick={() => setScreen(0)}
    >
      {/* Overlay */}
    

      {/* Popup Content */}
      <div
        className="relative z-10 w-full h-full overflow-y-auto custom-scrollbar rounded-md bg-white shadow-custom flex flex-col"
        onClick={(e) => {
            e.stopPropagation()
            // setScreen(0)
        }
        } // Prevent closing when clicking inside the popup
        
      >
        <div className=" w-full flex justify-between text-white items-center border-b-2 pb-2 px-4 bg-[#50869A]">
         

            <div className="flex w-full md:w-auto justify-start gap-4">
    <div className="flex flex-col items-center justify-center gap-1">
      <div className="relative mt-2 items-center flex justify-center w-[65px] h-[65px]">
        <div
          className="relative flex justify-center items-center w-[65px] h-[65px] rounded-full"
     
        >
          <div className="flex justify-center items-center w-[55px] h-[55px] bg-[#FAFAF9] rounded-full">
            <div className="flex justify-center items-center w-[45px] h-[45px] bg-[#C4C4C4] rounded-full">
            <img 
            
             onClick={() => {
  navigate('/landing', {
    state: { fromPatientId: selectedAppointment.patientid }
  });
}}
            className="flex justify-center items-center w-[45px] h-[45px] bg-[#C4C4C4] rounded-full cursor-pointer"
                     onError={(e) => e.target.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg=='}
                     src={`/cloud-assets/chim/public/assets/images/profilepictures/${selectedAppointment.patientid}.png`} alt='%/'/>
            </div>
          </div>
          {/* <div
            style={smallCircleStyle}
            className="flex justify-center items-center"
          >
            <div className="text-[8px] font-bold text-black">{percentage}%</div>
          </div> */}
        </div>
      </div>

    </div>
             </div>

  <div className="flex  flex-wrap items-start flex-col py-2 my-0 w-full gap-2 pl-3">
 
      <div className="flex justify-start items-center my-0 gap-1 ">
      <div className="w-[auto] font-bold   text-center font-[25px] text-[white] whitespace-nowrap cursor-pointer"
   onClick={() => {
  navigate('/landing', {
    state: { fromPatientId: selectedAppointment.patientid }
  });
}}
      >
      {selectedAppointment.firstname} {selectedAppointment.lastname}
      </div>
      <div className="w-[auto] px-[6px] py-[2px] rounded-full bg-gray-400 text-center font-inter text-[white]  text-xs md:text-xs">
        #{selectedAppointment.patientid}
      </div>
        </div>
<div className='flex gap-4 my-0 '>
<div className="flex justify-start items-center  gap-1 w-full md:w-auto">
   <div className="font-light text-[white] text-xs md:text-sm">
     <img src={calender} alt='$/'/>
   </div>
   <div className="relative text-[13px] md:text-[15px] text-[white]">
   {selectedAppointment.dob}
   </div>
 </div>
 <div className="flex  justify-start items-center  gap-1 w-full md:w-auto">
   <div className="font-light text-[white] text-xs md:text-sm">
     <img src={phone} alt='$/'/>
   </div>
   <div className="relative text-[13px] md:text-[15px] text-[white]">
{selectedAppointment.phone}
   </div>
 </div>

 <div className="flex  justify-start items-center   gap-1 w-full md:w-auto">
   <div className="font-light text-[white] text-xs md:text-sm">
   <img src={dollar} alt='%'/>
   </div>
   <div className="relative text-[13px] md:text-[15px] text-[white]">
   {selectedAppointment.insurancename}
   </div>
  <div className="relative text-[13px] md:text-[15px] text-[white]">
    {recordingProvider && <MicIcon />}{recordingProvider}
  </div>
   
 </div>
</div>
 


    </div>
     
<div className='flex gap-4 '>



 {/* Close Icon Button */}
         <IconButton
            edge="end"
            aria-label="close"
            onClick={() => {
              if(flow=='db'){
setScreen(false)
setIsAptcard(false)
return
              }
              setScreen(0)}}
            style={{ color: '#ffffff' }}
          >
            <CloseIcon />
          </IconButton>

</div>
         
        </div>
<div className="w-full mt-4 flex  justify-between">
 
 
      <div onClick={() => {
          setShowAppointmentForm(true);
          setOrderSchedule(false)
       setIsReschedule(false); 
      
      }}   
      className={`cursor-pointer mx-3 font-sans font-normal text-xs md:text-[14px] tracking-tight text-center rounded shadow-md flex items-center justify-center transition-colors duration-300 ease-in-out 
    bg-[#E17954] text-white py-[10px] px-4 md:px-10   whitespace-nowrap`}
    > + Create Appointment
    </div>



  <div className="w-full md:w-auto flex  gap-2 md:mt-0 mr-4">   
  {/* <div
  onClick={() => {
    if (!disablebuttons.includes(selectedAppointment?.visit_confirmation)&&
     tableData[selectedCard]?.visit_confirmation
 !== "Cancelled") {

    setIsReschedule(true);
      setShowAppointmentForm(true);
    
      setOrderSchedule(false)
    }
  }}
  className={`rounded mx-2 flex items-center gap-1 font-inter px-3 text-[12px] bg-[#DBEAFE] text-[#7E22CE] shadow-md truncate
    ${disablebuttons.includes(selectedAppointment?.visit_confirmation)||
      tableData[selectedCard]?.visit_confirmation
 === "Cancelled"
      ? "opacity-50 cursor-not-allowed pointer-events-none"
      : "cursor-pointer"
    }`}
>
  <img src={reschedule} className="w-4 h-4" alt="reschedule icon" />
  <div>Reschedule</div>
</div> */}
<div
  onClick={() => {
    const visitStatus = tableData[selectedCard]?.visit_confirmation;

    if (
      (tableData[selectedCard]=== "" || !disablebuttons.includes(visitStatus)) &&
      tableData[selectedCard]?.visit_confirmation !== "Cancelled"
    ) {
      setIsReschedule(true);
      setShowAppointmentForm(true);
      setOrderSchedule(false);
    }
  }}
  className={`rounded mx-2 flex items-center gap-1 font-inter px-3 text-[12px] bg-[#DBEAFE] text-[#7E22CE] shadow-md truncate
    ${
      (tableData[selectedCard]?.visit_confirmation !== "" &&
        disablebuttons.includes(tableData[selectedCard]?.visit_confirmation)) ||
      tableData[selectedCard]?.visit_confirmation === "Cancelled"
        ? "opacity-50 cursor-not-allowed pointer-events-none"
        : "cursor-pointer"
    }`}
>
  <img src={reschedule} className="w-4 h-4" alt="reschedule icon" />
  <div>Reschedule</div>
</div>

 <Tooltip title={orderOptions?.length === 0 ? 'No orders found' : ''}>
<div
  onClick={(e) => {
  if (
  tableData[selectedCard]?.visit_confirmation === "Cancelled" ||
  !dayjs(tableData[selectedCard]?.startdate).isSame(dayjs(), 'day') ||
  checkoutloading ||
  selectedAppointment?.visit_confirmation === "Checked Out"
) {
  return;
}

 if(isfutureappointment)return
    e.stopPropagation();

    if (orderOptions?.length === 0) {
      setCheckoutconformation(true);
    } else {
      if(flow!=='db'){
               setNavigateTo(1);
                  setScreen(4); 
        }else{
          setScreen(0)
        }
   
    
    }
  }}
  className={`rounded px-3 flex items-center gap-1 font-inter mx-2 text-[12px] shadow-md truncate
    ${
      checkoutloading || isfutureappointment || selectedAppointment?.visit_confirmation === "Checked Out"||   tableData[selectedCard]?.visit_confirmation
 === "Cancelled"|| !dayjs(tableData[selectedCard]?.startdate).isSame(dayjs(), 'day')
        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
        : "bg-[#DBEAFE] text-[#1D4ED8] cursor-pointer"
    }`}
  style={{ opacity: checkoutloading || selectedAppointment?.visit_confirmation === "Checked Out" ? 0.6 : 1 }}
>
  <img
    src={checkout}
    alt="checkout"
    className={`w-4 h-4 ${checkoutloading ? "animate-spin" : ""}`}
  />
  <div>Checkout</div>
</div>


</Tooltip>
<div
  onClick={() => {
if (
  (flow !== "db" && isfutureappointment) ||
  !dayjs(tableData[selectedCard]?.startdate).isSame(dayjs(), 'day') ||
  tableData[selectedCard]?.visit_confirmation === "Cancelled" ||
  tableData.length === 0 ||
  selectedAppointment?.visit_confirmation === "Checked Out"
) {
  return;
}

    setScreen(3);
  }}
  className={`rounded flex items-center gap-1 font-inter mx-2 px-3 text-[12px] bg-[#DBEAFE] text-[#15803D] shadow-md truncate
    ${
      tableData.length === 0 || (flow !== "db" && isfutureappointment)|| selectedAppointment?.visit_confirmation === "Checked Out"||   tableData[selectedCard]?.visit_confirmation
 === "Cancelled"||!dayjs(tableData[selectedCard]?.startdate).isSame(dayjs(), 'day')

        ? "cursor-not-allowed opacity-50 pointer-events-none"
        : "cursor-pointer"
    }`}
>
  <img src={payment} alt="$?" className="w-4 h-4" />
  <div>Take Payment</div>
</div>

<div
  onClick={() => {
   const visitStatus = tableData[selectedCard]?.visit_confirmation;

  if (visitStatus === "Cancelled") return;

  if (!disablebuttons.includes(visitStatus || "")) {
    setOpenCancelModal(true);   // 👈 open modal instead
  }
  }}
  className={`rounded flex items-center gap-1 font-inter mx-2 px-3 text-[12px] bg-[#FEE2E2] text-[red] shadow-md truncate
    ${   tableData[selectedCard]?.visit_confirmation &&
      (disablebuttons.includes(tableData[selectedCard]?.visit_confirmation) ||
        tableData[selectedCard]?.visit_confirmation === "Cancelled")
      ? "opacity-50 cursor-not-allowed pointer-events-none"
      : "cursor-pointer"
    }`}
>
  <CloseIcon className="w-3 h-3" style={{ width: '15px' }} />
  <div>Cancel</div>
</div>


  </div>
 </div>


<div className='flex justify-between mt-4 w-full flex-col sm:flex-row   px-4'>
<div className='flex flex-col gap-2  w-[53%]'>
<div className='text-left text-[#50869A] font-semibold'>Upcoming Appointments</div>
  <div className='flex flex-col gap-2  w-[100%] p-1 max-h-[285px] overflow-y-auto custom-scrollbar'>
  {isLoading ? (
  <div className="flex justify-center items-center py-4">
<div className="w-8 h-8 border-4 border-t-4 border-transparent rounded-full animate-spin" 
     style={{
       borderTopColor: 'rgba(0, 0, 0, 0.2)', 
       borderRightColor: 'rgba(0, 0, 0, 0.4)', 
       borderBottomColor: 'rgba(0, 0, 0, 0.6)', 
       borderLeftColor: 'rgba(0, 0, 0, 0.8)',
     }}></div>
</div>
) : tableData.length === 0 ? (
  <div className="flex justify-center items-center py-4 text-gray-500">
    No Data Found
  </div>
) : (
  tableData.map((upcomming, id) => (
    <div
      key={id}
      onClick={() => handleCardClick(upcomming,id)}  // Set the clicked card's index
      className={`relative w-[100%] cursor-pointer flex py-2 pr-2 items-center 
                  ${selectedCard === id ? 'bg-[#E5E7EB] border-l-4  border-[#E17954]' : 'bg-[white] border-b-[1px]'} 
                  rounded-[10px] h-auto  `}
     style={{
    clipPath: selectedCard === id
      ? 'polygon(0 0, calc(100% - 20px) 0, 100% 50%, calc(100% - 20px) 100%, 0 100%)'
      : 'none',
    // boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)',
    boxShadow: "0 0 1px rgba(0, 0, 0, 0.05)",
    transition: 'clip-path 0.3s ease'
  }}
    >
      <div className="flex ml-2">
        <div className="flex flex-col">
          <div className="flex gap-2 items-center">
          {outlinedbluecalender}
            <div className="font-inter text-[black] text-xs leading-4 whitespace-nowrap">
              {dayjs(upcomming.startdate).format('ddd, MMMM D')} {/* Use the startdate from upcomming */}
            </div>
          </div>
          <div className="flex w-full gap-2 items-center">
        {outlinedblueclock}
            <div className="font-normal text-[black] font-inter text-xs leading-4 whitespace-nowrap">
              {dayjs(`1970-01-01T${upcomming.starttime}`).format('h:mm A')}
      
            </div>
          </div>
        </div>
      </div>

      <div className="w-full items-start justify-start flex gap-1 mt-1 flex-col ml-2 whitespace-nowrap">
        <button className="rounded-full border-[1px] font-inter border-[#50869A] px-2 text-[11px] bg-[#ffffff] text-[#50869A] shadow-md truncate">
          {upcomming.type}
        </button>
      <div
  className={`inline-flex items-center gap-1 px-2 py-[2px] rounded-full font-inter text-[10px]
  ${
    upcomming.visit_confirmation?.toLowerCase().includes("cancel")
      ? "bg-red-50 text-red-600 font-semibold border border-red-200"
      : "text-[#6B7280]"
  }`}
>
  {upcomming.visit_confirmation}
</div>
      </div>

      <div className="items-center">
        <button className="rounded-full px-1 text-[12px] bg-[#E17954] text-white shadow-md truncate">
          {upcomming.providername}
        </button>
      </div>
    </div>
  ))
)}

  </div>
</div>

<div className='w-[45%] flex flex-col  '>
<div className=" font-semibold text-[#50869A]  mb-1 text-left text-[18px]">
Orders 
      </div>
<div class="flex gap-2">
<div className="p-2 flex flex-col rounded border-[1.5px] border-gray-200 w-[50%] ">
  {/* Today Orders */}
  <div className="text-left font-inter text-[#50869A]">Today's Orders</div>
  <div className='max-h-[400px] overflow-auto custom-scrollbar'>
 {isOrderLoading ? (
    <div className="w-full text-center text-gray-500 p-2">
      <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 border-t-transparent border-gray-100 rounded-full" role="status">
        {/* No loading text here */}
      </div>
    </div>
  ) : orderOptions.filter(order => order.schedule === "f" && order.ordertype !== "Prescription" && order.ordertype !== "Notes").length > 0 ? (
    orderOptions.filter(order => order.schedule === "f" && order.ordertype !== "Prescription" && order.ordertype !== "Notes").map((order, index) => (
      <div key={index} className="w-full flex my-[2px]  flex-col justify-between border-[1.5px] border-gray-200 rounded-[8px] ">
        <div className="flex items-center justify-between gap-4 w-full p-2 border-r-1 border-l-1">
          <div className="relative flex text-sm md:text-[15px] font-semibold text-[#1D2951]">
            {order.ordername}
          </div>
          <div className='flex items-center gap-2'>

 <div
  className={`text-xs font-medium px-2 py-[2px] rounded-full border-[1px] ${
    order.status === 'CREATED'
      ? 'text-[#CA8A04] border-[#CA8A04]'
      : 'text-[#16A34A] border-[#16A34A]'
  }`}
>
  {order.status === 'CREATED' ? 'Pending' : order.status}
</div>
{order.ordertype=='Schedule-RTO'?<div
onClick={()=>{
     setShowAppointmentForm(true);
          setOrderSchedule(true)
       setIsReschedule(false); 
       setSelectedScheduleOrder(order)
       setSelectedOrders([order])
}}
className='cursor-pointer'>

  {calendericonblue}
</div>:<></>}


          </div>
             


        </div>
        <div className="flex justify-between w-full p-2 items-end">
          <div className="flex w-full justify-between">
            <div className="relative text-sm md:text-[13px] text-[#4B5563] text-left">
 {order.ordertype?.charAt(0).toUpperCase() + order.ordertype?.slice(1)}

            </div>
            <div className="text-left text-[#6B7280] text-sm tracking-[0] leading-4 whitespace-nowrap">
        {(() => {
    const dateStr = order?.ts?.split(' ')[0]; // safely access date part
    if (!dateStr || !/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      return '';
    }

    const [year, month, day] = dateStr.split('-');
    return `${+month}/${+day}/${year}`;
  })()}

            </div>
          </div>
        </div>
      </div>
    ))
  ) : (
    <div className="w-full text-center text-gray-500 p-2">
      No data found
    </div>
  )}


  </div>
 

  {/* Schedule Orders */}
</div>



<div className="p-2 flex flex-col rounded border-[1.5px] border-gray-200 w-[50%]">
  {/* Today Orders */}
  <div className="text-left font-inter text-[#50869A]">Scheduled Orders</div>
    <div className='max-h-[400px] overflow-auto custom-scrollbar'>
 {isOrderLoading ? (
    <div className="w-full text-center text-gray-500 p-2">
      <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 border-t-transparent border-gray-100 rounded-full" role="status">
        {/* No loading text here */}
      </div>
    </div>
  ) : orderOptions.filter(order => order.schedule === "t" && order.ordertype !== "Prescription" && order.ordertype !== "Notes").length > 0 ? (
    orderOptions.filter(order => order.schedule === "t" && order.ordertype !== "Prescription" && order.ordertype !== "Notes").map((order, index) => (
      <div key={index} className="w-full flex my-[2px]  flex-col justify-between border-[1.5px] border-gray-200 rounded-[8px]">
        <div className="flex items-center justify-between gap-4 w-full p-2 border-r-1 border-l-1">
          <div className="relative flex text-sm md:text-[15px] font-semibold text-[#1D2951]">
            {order.ordername}
          </div>
          <div className='flex gap-2 items-center'>
        <div
  className={`text-xs font-medium px-2 py-[2px] rounded-full border-[1px] ${
    order.status === 'CREATED'
      ? 'text-[#CA8A04] border-[#CA8A04]'
      : 'text-[#16A34A] border-[#16A34A]'
  }`}
>
  {order.status === 'CREATED' ? 'Pending' : order.status}
</div>
{order.status!='COMPLETED'&&<div
onClick={()=>{
     setShowAppointmentForm(true);
          setOrderSchedule(true)
       setIsReschedule(false); 
       setSelectedScheduleOrder(order)
       setSelectedOrders([order])
}}
className='cursor-pointer'>

  {calendericonblue}
</div>}



          </div>

        </div>
        <div className="flex justify-between w-full p-2 items-end">
          <div className="flex w-full justify-between">
            <div className="relative text-sm md:text-[13px] text-[#4B5563] text-left">
          {order.ordertype?.charAt(0).toUpperCase() + order.ordertype?.slice(1)}

            </div>
            <div className="text-left text-[#6B7280] text-sm tracking-[0] leading-4 whitespace-nowrap">
              {(() => {
    const dateStr = order?.ts?.split(' ')[0]; // safely access date part
    if (!dateStr || !/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      return '';
    }

    const [year, month, day] = dateStr.split('-');
    return `${+month}/${+day}/${year}`;
  })()}
            </div>
          </div>
        </div>
      </div>
    ))
  ) : (
    <div className="w-full text-center text-gray-500 p-2">
      No data found
    </div>
  )}


  </div>
 
  {/* Schedule Orders */}
</div>

</div>





</div>

</div>
{/* Create Appointerment */}
{showAppointmentForm &&
 <AppointmentCard

 fetchdata={()=>{
      fetchdata(selectedDate.format('YYYY-MM-DD'))  
 }}
 selectedOrders={selectedOrders} setSelectedOrders={setSelectedOrders}
 handleaddnoteClick={handleaddnoteClick}
  handleDateChange={handleDateChange} 
  selectedDate={selectedDate} 
  showTextArea={showTextArea}
  selectedAppointment={selectedAppointment}
  setSelectedDate={setSelectedDate}
tableData={tableData}
selectedCard={selectedCard}
orderOptions={orderOptions}
  provider={provider}
  setProvider={setProvider}
  selectedSlot={selectedSlot}
  setSelectedSlot={setSelectedSlot}
  appointmentname={appointmentname}
  setAppointmentName={setAppointmentName}
  setAppointmentType={setAppointmentType}
  appointmentType={appointmentType}
  providername={providername}
  setProvidername={setProvidername}
  isReschedule={isReschedule}
  rowId={rowId}
  isorderschedule={isorderschedule}
  selectedscheduleorder={selectedscheduleorder}
  /> 
  } 
  <ConfirmCheckoutModal
  isOpen={CheckoutConformation}
  onClose={() => setCheckoutconformation(false)}
  onCheckout={() => {
 checkoutuser();
    setCheckoutconformation(false);
  }}
/>
<ConfirmCancelModal
  open={openCancelModal}
  onClose={() => setOpenCancelModal(false)}
  onConfirm={() => {
    deleteAppointment(rowId);
    setOpenCancelModal(false);
  }}
/>

    <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
      </div>
    </div>
  );
};

export default CreateAppointment;
